import { useMantineTheme } from '@mantine/core';
import type { EdgeProps } from 'reactflow';
import { BaseEdge, getBezierPath } from 'reactflow';
import type { EdgeData } from '../types.ts';
import { EntityEdgeWithJob } from './EntityEdgeWithJob.tsx';

export function EntityEdge({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	sourcePosition,
	targetPosition,
	markerEnd,
	data,
}: EdgeProps<EdgeData>) {
	const theme = useMantineTheme();

	const [edgePath, labelX, labelY] = getBezierPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
	});

	// Determine edge styling based on lineageArchived status
	let strokeDasharray = 'none';

	if (data?.lineageArchived) {
		// Archived lineage: dashed line to indicate archived status
		strokeDasharray = '5,5';
	}

	const style = {
		stroke: theme.other.getColor('border/tertiary/default'),
		strokeWidth: 1,
		strokeDasharray,
	};

	return !data?.hasConnectionToJob && data?.metadata ? (
		<EntityEdgeWithJob
			id={id}
			path={edgePath}
			labelX={labelX}
			labelY={labelY}
			markerEnd={markerEnd}
			style={style}
			isHovered={data.isHovered}
			metadata={data.metadata}
		/>
	) : (
		<BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
	);
}
